// Client-side validation for the login form submit state.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["email", "password", "submit"];

    connect() {
        console.log("LoginFormController connected")
        this.validate()
    }

    validate() {
        const emailValid = this.emailTarget.value.trim().length > 0;
        const passwordValid = this.passwordTarget.value.trim().length >= 6;

        this.submitTarget.disabled = !(emailValid && passwordValid);
    }
}
